import { MantineTheme } from '@mantine/core';
import React, { CSSProperties } from 'react';
import { DateInputStylesNames, DayOfWeek } from '@mantine/dates';
import { getDatePickerZIndex } from '../utils/zIndexLayers';

// Provide these as functions that return props
export const getDateInputProps = () => ({
    clearable: true,
    popoverProps: {
        withinPortal: true,
        width: "auto",
        shadow: "md",
        zIndex: getDatePickerZIndex() // Higher than modal z-index
    },
    classNames: {
        calendarHeader: "calendar-header",
        month: "calendar-month"
    },
    firstDayOfWeek: 1 as DayOfWeek,
    getDayProps: (date: Date) => {
        const isWeekend = date.getDay() === 0 || date.getDay() === 6;
        const isToday = new Date().toDateString() === date.toDateString();
        
        const style: React.CSSProperties = {};
        
        if (isWeekend) {
            style.color = 'var(--mantine-color-red-6)';
        }
        
        if (isToday) {
            style.fontWeight = 'normal';
            style.color = 'var(--mantine-color-blue-6)';
            style.textDecoration = 'underline';
            style.textUnderlineOffset = '3px';
        }
        
        return { style };
    }
});

// Simple string-based icons
export const nextIconElement = () => '›';
export const previousIconElement = () => '‹';

// Use proper types for CSS properties
export const dateInputStyles = (theme: MantineTheme): Record<string, any> => ({
    root: { maxWidth: '100%', width: '100%' },
    input: {
        height: '36px',
        fontSize: '14px'
    },
    day: {
        height: '36px',
        width: '36px',
        fontSize: '14px',

        '&:hover': {
            backgroundColor: 'var(--mantine-color-gray-0)'
        }
    },
    weekday: {
        fontWeight: 'normal',
        fontSize: '0.875rem',
        padding: '0.5rem 0',
        color: theme.colors.gray[6],
        textTransform: 'uppercase' as const,
    },
    monthPickerControl: {
        width: '100%',
        textAlign: 'center' as const
    },
    calendarHeaderControl: {
        color: theme.colors.gray[7],
        borderRadius: '4px',
        width: '24px',
        height: '24px',
        fontSize: '1rem',
        fontWeight: 600
    },
    calendarHeader: {
        padding: '10px'
    },
    calendarHeaderControlIcon: {
        width: '16px',
        height: '16px'
    },
    calendarHeaderLevel: {
        justifyContent: 'space-between' as const,
        padding: '0 8px'
    },
    yearLevel: {
        padding: '10px'
    },
    monthLevel: {
        padding: '10px'
    }
}); 